import * as React from 'react';
import { Body1 } from '@cian/ui-kit';
import * as style from './style.css';

import { ITransportPointCell } from '../../../../../../types/newbuildingsCompare';
import { TransportPointIcon } from '../shared/TransportPointIcon';

export interface ITransportPointCellProps {
  cell: ITransportPointCell;
}

/**
 * Строка «Метро, шоссе» мобильной таблицы: только названия точек, без расстояний —
 * они приходят отдельной строкой transportDistance.
 */
export const TransportPointCell = ({ cell }: ITransportPointCellProps): React.JSX.Element => {
  const transportPoints = cell.data?.transportPoints;

  if (!transportPoints?.length) {
    return (
      <div className={style['container']}>
        <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
      </div>
    );
  }

  return (
    <div className={style['container']}>
      {transportPoints.map((point, index) => (
        <div className={style['point']} key={`${point.name}-${index}`}>
          <TransportPointIcon className={style['icon']} point={point} />
          <Body1 color="text-primary-default">{point.name}</Body1>
        </div>
      ))}
    </div>
  );
};
